import React from 'react';
import { Link } from 'react-router-dom';
import { Trash2, ShoppingBag } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';

const Wishlist = () => {
  const { wishlist, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();

  const handleMoveToCart = (product) => {
    addToCart(product, product.sizes[0]);
    removeFromWishlist(product.id);
  };

  if (wishlist.length === 0) {
    return (
      <div className="bg-cream min-h-screen">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 text-center">
          <h1 className="font-serif text-4xl md:text-5xl text-charcoal mb-6" data-testid="empty-wishlist-title">
            Your Wishlist is Empty
          </h1>
          <p className="text-[#6B665F] font-light text-lg mb-8">
            Save your favorite pieces for later
          </p>
          <Link
            to="/shop"
            className="inline-block bg-bronze text-white px-10 py-4 rounded-full hover:bg-bronze-dark transition-all duration-300 text-sm uppercase tracking-widest font-medium"
            data-testid="shop-now-button"
          >
            Shop Now
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-cream min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <h1 className="font-serif text-4xl md:text-5xl text-charcoal mb-12" data-testid="wishlist-page-title">
          My Wishlist
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="wishlist-items">
          {wishlist.map((product) => (
            <div
              key={product.id}
              className="bg-white border border-[#E5E0D8] overflow-hidden group"
              data-testid={`wishlist-item-${product.id}`}
            >
              <Link to={`/product/${product.id}`} className="block aspect-[3/4] overflow-hidden">
                <img
                  src={product.images[0]}
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </Link>
              
              <div className="p-6">
                <Link to={`/product/${product.id}`}>
                  <h3 className="font-serif text-lg text-charcoal mb-2 group-hover:text-bronze transition-colors">
                    {product.name}
                  </h3>
                </Link>
                <p className="text-bronze font-medium mb-4">
                  ₹{product.price.toLocaleString()}
                </p>
                
                <div className="flex gap-3">
                  <button
                    onClick={() => handleMoveToCart(product)}
                    className="flex-1 bg-bronze text-white px-4 py-3 rounded-full hover:bg-bronze-dark transition-all duration-300 text-xs uppercase tracking-widest font-medium flex items-center justify-center gap-2"
                    data-testid={`move-to-cart-${product.id}`}
                  >
                    <ShoppingBag size={16} />
                    Add to Cart
                  </button>
                  <button
                    onClick={() => removeFromWishlist(product.id)}
                    className="px-4 py-3 border border-[#E5E0D8] rounded-full hover:border-red-500 hover:text-red-500 transition-all duration-300"
                    data-testid={`remove-from-wishlist-${product.id}`}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Wishlist;
